import React from 'react';
import { Text } from '@ovos-media/templates/dist/sp';
import { generateUrl } from '../domains/uploads';

export default ({ file_audio_id, ...props }) => (
  <Text
    {...props}
    audioSource={generateUrl(file_audio_id)}
  />
);